module.exports = __webpack_public_path__ + "media/images/front/bg_products_header_01-6e7ca36b4c96504ad2b707101fcdcace.jpg";